import {
  DebentureApiResponse,
  GETInstrumentosFilterParams,
  CadastroDebentureApiRequest,
  SolicitarLiquidacaoRequest,
  HistoricoResponse,
  DocumentRequest,
  CommandResultTyped,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETDebentureDetalhes,
  GETDebentures,
  POSTDebenture,
  PUTDebenture,
  POSTInterOpDebenture,
  POSTEnviarLiquidacao,
  GETHistoricoDebenture,
  POSTConfirmarLiquidacaoDebenture,
  PUTUploadDoc as PUTUploadDocDebenture,
  DELETEUploadDoc as DELETEUploadDocDebenture,
  GETDebentureByInstrumentoId,
  PUTDebentureAditamento,
  PutEditarDebenture,
  GETAditamentoDebenture,
  PUTAditamentoDebenture,
} from 'requests/debenture';
import { UploadDocResponse } from '../models/uploadDocResponse';
import { typedAction } from 'store/modules/base';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export interface DebentureApiState {
  getDebentureDetalhes(dispatch: Dispatch, id: string, stackRequest?: boolean): Promise<DebentureApiResponse>;
  getDebentures(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<DebentureApiResponse>>;
  getDebentureByInstrumentoId(
    dispatch: Dispatch,
    instrumentoId: string,
    stackRequest?: boolean
  ): Promise<DebentureApiResponse>;
  postDebenture(
    dispatch: Dispatch,
    debenture: CadastroDebentureApiRequest,
    stackRequest?: boolean
  ): Promise<DebentureApiResponse>;
  putDebenture(
    dispatch: Dispatch,
    debentureId: string,
    debenture: CadastroDebentureApiRequest,
    stackRequest?: boolean
  ): Promise<DebentureApiResponse>;
  putEditarDebenture(
    dispatch: Dispatch,
    debentureId: string,
    debenture: CadastroDebentureApiRequest,
    justificativa: string,
    document?: File | undefined,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<string>>;
  putDebentureAditamento(
    dispatch: Dispatch,
    debentureId: string,
    debenture: CadastroDebentureApiRequest,
    date: string,
    document: File,
    stackRequest?: boolean
  ): Promise<string>;
  putUploadDoc(
    dispatch: Dispatch,
    debentureId: string,
    emissionType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<Array<UploadDocResponse>>;
  deleteUploadDoc(
    dispatch: Dispatch,
    debentureId: string,
    debentureDocumentId: string,
    stackRequest?: boolean
  ): Promise<unknown>;
  postInterOpDebenture(
    dispatch: Dispatch,
    debenture: CadastroDebentureApiRequest,
    stackRequest?: boolean
  ): Promise<DebentureApiResponse>;
  postEnviarLiquidacao(
    dispatch: Dispatch,
    debentureId: string,
    debentureSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<DebentureApiResponse>;
  postConfirmarLiquidacaoDebenture(
    dispatch: Dispatch,
    debentureId: string,
    precoUnitarioLiquidacao: number,
    stackRequest?: boolean
  ): Promise<DebentureApiResponse>;
  getHistoricoDebenture(
    dispatch: Dispatch,
    debentureId: string,
    stackRequest?: boolean
  ): Promise<Array<HistoricoResponse>>;
  getAditamentoDebenture(
    dispatch: Dispatch,
    aditamentoId: string,
    stackRequest?: boolean
  ): Promise<AditamentoRevisionData>;
  putAditamentoDebenture(
    dispatch: Dispatch,
    aditamentoId: string,
    diferenca: AditamentoDiferenca[],
    stackRequest?: boolean
  ): Promise<Array<AditamentoDiferenca>>;
}

export const debentureApiInicialState: DebentureApiState = {
  getDebentureDetalhes: GETDebentureDetalhes,
  getDebentures: GETDebentures,
  getDebentureByInstrumentoId: GETDebentureByInstrumentoId,
  postDebenture: POSTDebenture,
  putDebenture: PUTDebenture,
  putEditarDebenture: PutEditarDebenture,
  putDebentureAditamento: PUTDebentureAditamento,
  putUploadDoc: PUTUploadDocDebenture,
  deleteUploadDoc: DELETEUploadDocDebenture,
  postInterOpDebenture: POSTInterOpDebenture,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  postConfirmarLiquidacaoDebenture: POSTConfirmarLiquidacaoDebenture,
  getHistoricoDebenture: GETHistoricoDebenture,
  getAditamentoDebenture: GETAditamentoDebenture,
  putAditamentoDebenture: PUTAditamentoDebenture,
};

enum DebentureApiActionType {
  Update = 'debentureApi/UPDATE',
  Reset = 'debentureApi/RESET',
}

export const updateDebentureApi = (state: DebentureApiState) => {
  return typedAction(DebentureApiActionType.Update, state);
};

export const resetDebentureApi = () => {
  return typedAction(DebentureApiActionType.Reset);
};

type DebentureApiAction = ReturnType<typeof updateDebentureApi | typeof resetDebentureApi>;

export function debentureApiReducer(
  state: DebentureApiState = debentureApiInicialState,
  action: DebentureApiAction
): DebentureApiState {
  switch (action.type) {
    case DebentureApiActionType.Update:
      return { ...action.payload };
    case DebentureApiActionType.Reset:
      return { ...debentureApiInicialState };
    default:
      return state;
  }
}
